<form [formGroup]="cancellationForm" class="popup-card">
  <h2 mat-dialog-title>Are you sure you want to cancel?</h2>
  <mat-dialog-content>
    <div class="mb-[15px]">
      <div class="text-[14px] text-[#5B5B5B] mb-[5px]">
        Reason for Cancellation
      </div>
      <div class="relative">
        <mat-form-field appearance="outline" class="w-full">
          <mat-select required formControlName="reason" class="text-[14px]">
            <mat-option value="">Select Cancellation Reason</mat-option>
            <mat-option
              *ngFor="let option of data.cancellationReasons"
              [value]="option.code"
            >
              {{ option.title }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="cancellationForm.get('reason').hasError('required')"
          >
            Please select valid cancellation Reason
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <!-- re / -->
    <!-- re -->
    <div class="mb-[15px]">
      <div class="text-[14px] text-[#5B5B5B] mb-[5px]">Comments</div>
      <div class="relative">
        <textarea
          formControlName="comment"
          placeholder="Please tell us why you want to cancel this order item."
          class="resize-none p-[10px] rounded-none border border-solid bg-transparent w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[120px]"
          style="border-color: #dfdfdf !important"
        ></textarea>
      </div>
    </div>
    <!-- re / -->
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      mat-dialog-close
      class="mt-auto w-full font-bold border bg-[#DFDFDF] text-[#5B5B5B] text-[14px] rounded-[5px] mb-[10px] border-[#DFDFDF]"
      style="padding: 8px 35px"
    >
      Close
    </button>
    <button
      mat-buttons
      [disabled]="cancellationForm.invalid"
      [mat-dialog-close]="cancellationForm.value"
      class="mt-auto w-full font-bold border bg-[#F94D00] disabled:bg-[#ffffff] text-[#FFFFFF] disabled:text-[#5B5B5B] disabled:cursor-not-allowed text-[14px] rounded-[5px] mb-[10px] border-solid disabled:border-[#DFDFDF]"
      style="padding: 8px 35px"
    >
      Confirm cancellation
    </button>
  </mat-dialog-actions>
</form>
